import { Inject, Injectable } from '@angular/core';
import { CodeValueConversionMstDto, Sgkz021aRequest, sgkz021aRequestCnversDiscrmClscodDto, SGKZ021AService } from 'sg-api';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { FeaturesLibConfig } from '../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../config/features-lib-config.token';

/**
 * 変換識別種別コードに紐づくコード値変換マスターのデータを取得する。
 * @export
 * @class CodeValueConversionMstService
 */
@Injectable({
  providedIn: 'root'
})
export class CodeValueConversionMstService {

  /**
   * コンストラクタ
   * @memberof CodeValueConversionMstService
   */
  constructor(private sGKZ021AService: SGKZ021AService, private apiCommonService: ApiCommonService, @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) {
  }

  /**
   * コード値変換マスタ
   * @param cnversDiscrmClscodList 変換識別種別コードリスト
   * @returns コード値変換マスタ（key:変換識別種別コード）
   * @memberof CodeValueConversionMstService
   */
  public getCodeValueConversionMst(cnversDiscrmClscodList: string[]): Observable<Map<string, Array<CodeValueConversionMstDto>>> {

    let cnversDiscrmClscodDtoList = new Array<sgkz021aRequestCnversDiscrmClscodDto>;
    for (let cnversDiscrmClscod of cnversDiscrmClscodList) {
      let request: sgkz021aRequestCnversDiscrmClscodDto = {
        cnversDiscrmClscod: cnversDiscrmClscod
      };

      cnversDiscrmClscodDtoList.push(request);
    }

    let request: Sgkz021aRequest = {
      cnversDiscrmClscodList: cnversDiscrmClscodDtoList
    }

    return this.sGKZ021AService.kz10RSGKZ021APost(this.apiCommonService.setRequestCommon(<any>request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックする
            this.apiCommonService.checkError(response);
            
            let result = new Map<string, Array<CodeValueConversionMstDto>>();
            for (let key in response.body.codeValueConversionMstTbl) {
              result.set(key, response.body.codeValueConversionMstTbl[key]);
            }

            return result;
          }),

        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'sys', 'SGKZ021A');
          return throwError(err.message);
        })
      );
  }
}
